export default __webpack_public_path__ + "663da1f0cc1f2597625e133af334b9df.png";